import React from 'react';
import { bool, oneOf } from 'prop-types';

import Classes from './Skeleton.scss';

import SkeletonBase from './SkeletonBase';

const getTypeClassName = (type) => {
  switch (type) {
    case 'short':
      return Classes.Short;
    case 'long':
      return Classes.Long;
    default:
      return Classes.Long;
  }
};

const TextSkeleton = ({ type = 'long', withAnimation }) => {
  const typeClass = getTypeClassName(type);
  return <SkeletonBase className={`${Classes.TextSkeleton} ${typeClass}`} withAnimation={withAnimation} />;
};

TextSkeleton.propTypes = {
  type: oneOf(['short', 'long']),
  withAnimation: bool,
};

export default TextSkeleton;
